import { render, staticRenderFns } from "./ConfirmSelfie.vue?vue&type=template&id=ab18c77e&"
import script from "./ConfirmSelfie.vue?vue&type=script&lang=js&"
export * from "./ConfirmSelfie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports